import {
    set as localStorageSet,
    get as localStorageGet,
    sessionStorageSet,
    sessionStorageGet,
    sessionStorageRemove,
} from '@/utils/storageUtils';
import {SideTabKey} from '@/interface';

export const aiChatPanelShow = 'aiChatPanelShow';

/**
 * 某篇文档-超级助理「文案修改，原先是智能洞察」对话窗口，打开状态设置
 * @param docGuid
 */
export function setAiChatShow(docGuid: string) {
    if (!docGuid) {
        return;
    }

    const list = localStorageGet(aiChatPanelShow);
    localStorageSet(aiChatPanelShow, {
        ...list,
        [docGuid]: {
            docGuid,
            isExpanded: true,
            selectedTab: SideTabKey.Ai,
            isExternalNotComment: true,
        },
    });
}

// 触发超级助理面板展开的来源类型
export enum AIChatPanelExpandSource {
    other = 'other',
    // 刷新页面
    refresh = 'refresh',
    // 点击入口图标展开
    entryIcon = 'entryIcon',
    // 点击hover摘要卡片跳转展开
    summaryCard = 'summaryCard',
    // 点击如流消息摘要跳转展开
    IMSummary = 'IMSummary',
    // 新建文档展开
    newDoc = 'newDoc',
}

// 记录触发aiChat面板展开的标识，用于埋点
const openAIChatPanelFlagKey = 'openAIChatPanelFlagKey';
/**
 * 设置触发aiChat面板展开的标识
 */
export function setOpenAIChatPanelFlag(value: AIChatPanelExpandSource) {
    sessionStorageSet(openAIChatPanelFlagKey, value);
}

/**
 * 获取标识
 */
export function getOpenAIChatPanelFlag() {
    return sessionStorageGet(openAIChatPanelFlagKey);
}

/**
 * 移除标识
 */
export function removeOpenAIChatPanelFlag() {
    sessionStorageRemove(openAIChatPanelFlagKey);
}

// 记录触发aiChat面板展开的来源
export const aiChatPanelExpandSourceObj = {
    value: AIChatPanelExpandSource.other,
    /**
     * 获取聊天面板展开来源
     *
     * @returns 展开来源枚举值，默认为 Other。
     */
    getVal() {
        return aiChatPanelExpandSourceObj.value || AIChatPanelExpandSource.other;
    },
    reset() {
        aiChatPanelExpandSourceObj.value = AIChatPanelExpandSource.other;
    },
    init() {
        const flag = getOpenAIChatPanelFlag();
        if (flag) {
            aiChatPanelExpandSourceObj.value = flag;
            removeOpenAIChatPanelFlag();
        }
    },
};
